module.exports = __webpack_public_path__ + "img/foodics-f51.7ef57557.png";